// extracted by mini-css-extract-plugin
export var caretAnchor = "_ur-0";
export var dropdownContent = "_ur-1";